module.exports = __webpack_public_path__ + "static/media/appmobile3.75ca0b09.webp";